'use client';

import React from 'react';

import CreditCardIntro from '@/components/cards/CreditCardIntro';
import MoneyResources from '@/components/ui/MoneyResources';
import { CardCategory } from '@/data/credit-cards/models/categories';
import { Card } from '@/types/Card';

interface CategoryCardsLayoutProps {
  category: CardCategory;
}

export default function CategoryCardsLayout({ category }: CategoryCardsLayoutProps) {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      {/* Cards Grid */}
      <div className="container mx-auto">
        {category.cards.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {category.cards.map((card: Card) => (
              <div key={card.key as string} className="h-full">
                <CreditCardIntro card={card} />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 dark:text-gray-400 text-lg">目前此類別尚無推薦信用卡</p>
          </div>
        )}
      </div>

      {/* Money Resources Section */}
      <div className="mt-12">
        <MoneyResources />
      </div>
    </div>
  );
}
